import { PropTypes } from 'prop-types';
import React from 'react';
import { Icon } from '~/components';

export default function CustomTd({ name, isTop5 }) {
  return (
    <>
      {isTop5 && <Icon name="star" color="yellow" size={11} />}
      {name}
    </>
  );
}

CustomTd.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isTop5: PropTypes.bool,
};

CustomTd.defaultProps = {
  name: '',
  isTop5: false,
};
